import { AxiosService } from '../../axios/axios.service';
import { tAxiosCustomConfig } from '../../axios/axios.types';
import { parseUndeliveredCount } from './Messenger.functions';
import {
  tGetLeadsQueryParams,
  tGetLeadsResponse,
  tMessengerResponse,
} from './Messenger.types';
import type { tBoardUndeliveredCountParams } from '../Pipe/Pipe.types';

export const MessengerService = {
  getLeads: async function (
    currentWorkspaceId: string,
    queryParams?: tGetLeadsQueryParams,
  ): Promise<tMessengerResponse<tGetLeadsResponse>> {
    try {
      const config: tAxiosCustomConfig = {
        params: queryParams,
      };

      const response = await AxiosService.get<
        tMessengerResponse<tGetLeadsResponse>
      >(`/workspace/${currentWorkspaceId}/leads/filter`, config);

      return Promise.resolve(response);
    } catch (err) {
      return Promise.reject(err);
    }
  },
  searchLeads: async function (
    currentWorkspaceId: string,
    queryParams?: tGetLeadsQueryParams,
  ): Promise<tMessengerResponse<tGetLeadsResponse>> {
    try {
      const config: tAxiosCustomConfig = {
        params: queryParams,
      };

      const response = await AxiosService.get<
        tMessengerResponse<tGetLeadsResponse>
      >(`/workspace/${currentWorkspaceId}/leads/search`, config);

      return Promise.resolve(response);
    } catch (err) {
      return Promise.reject(err);
    }
  },
  /**
   * INT-1500 U14 (contract C9): how many leads in this user's list have an
   * undelivered latest message, for the "No entregados (N)" chip. Called with
   * the base params of the "Todos" list, or by the funnel board (INT-1596) with
   * its funnel and the filters its columns send. Resolves null for a body without a
   * count; rejects when the request fails. Not reported to Sentry: it
   * refreshes on socket traffic, and a failure only hides the chip.
   */
  getUndeliveredCount: async function (
    currentWorkspaceId: string,
    queryParams?: tGetLeadsQueryParams | tBoardUndeliveredCountParams,
  ): Promise<number | null> {
    const body = await AxiosService.get<unknown>(
      `/workspace/${currentWorkspaceId}/leads/undelivered/count`,
      { params: queryParams, skipSentryCapture: true },
    );
    return parseUndeliveredCount(body);
  },
};
